import { formatVideoUrl } from '@utils'
import classNames from 'classnames'
import { useMemo } from 'react'

export default function VideoPlayerContent({
  url,
  className
}) {

  const viewUrl = useMemo(() => formatVideoUrl(url), [url])

  return (
    <iframe src={viewUrl} className={classNames('w-full aspect-video image-loading', className)}></iframe>
  )
}